<template>
  <div>
    <el-drawer
      title="复制广告"
      :visible="visible"
      :append-to-body="true"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      size="720px"
      @close="$emit('close-drawer')"
      @opened="open"
    >
      <div class="copy-ad-series-container">
        <el-container>
          <el-main>
            <!--广告系列列表-->
            <div class="ad-series-wrapper">
              <div class="ad-series-title">
                <el-checkbox
                  :indeterminate="checkedAdSeries.length > 0 && checkedAdSeries.length < adSeriesArr.length"
                  :value="checkedAdSeries.length === adSeriesArr.length"
                  @change="handleCheckAllChange"
                  >已选{{ checkedAdSeries.length }}项</el-checkbox
                >
              </div>
              <div class="ad-series-content">
                <el-checkbox-group
                  v-model="checkedAdSeries"
                  @change="handleCheckedAdSeriesChange"
                >
                  <el-checkbox
                    v-for="adSeries in adSeriesArr"
                    :label="adSeries"
                    :key="adSeries.id"
                    :disabled="checkResult && needCheck(adSeries) && !adSeries.$checkResult.pass"
                    :checked="adSeries.checked"
                  >
                    <div class="ad-series-item">
                      <div class="name">{{ adSeries.name }}</div>
                      <!-- 复制状态 -->
                      <span
                        v-loading="results[adSeries.id] ? !results[adSeries.id].done : false"
                        v-if="begin"
                        style="width: 60px; text-align: center"
                      >
                        <!-- 没有错误信息 -->
                        <i
                          class="el-icon-circle-check"
                          v-if="results[adSeries.id] && !results[adSeries.id].hasError"
                          style="color: #67c23a"
                        ></i>
                        <!-- 有错误信息 -->
                        <el-tooltip
                          placement="top-start"
                          width="200"
                          trigger="hover"
                          v-if="results[adSeries.id] && results[adSeries.id].messages"
                        >
                          <p
                            v-for="(message, index) in results[adSeries.id].messages"
                            :key="index"
                            class="resultMessage"
                            slot="content"
                          >
                            <span :class="['point', message.level]"></span>
                            <span>{{ message.message }}</span>
                          </p>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </span>
                      <span
                        v-loading="checking"
                        v-if="checking"
                        >检测中...</span
                      >
                      <div
                        class="status"
                        v-if="checkResult && needCheck(adSeries)"
                      >
                        <i
                          class="el-icon-check"
                          style="color: #47c30f"
                          v-if="adSeries.$checkResult.pass"
                          >成功</i
                        >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          placement="left"
                          v-if="!checking"
                        >
                          <i
                            class="el-icon-close"
                            style="color: #ff0000"
                            v-if="!adSeries.$checkResult.pass"
                            >失败</i
                          >
                          <div
                            slot="content"
                            v-if="adSeries.$checkResult.checkResults.filter((s) => s.level !== 'ok').length > 0"
                          >
                            <div
                              v-for="(res, i) in adSeries.$checkResult.checkResults.filter((s) => s.level !== 'ok')"
                              :key="i"
                            >
                              <i
                                :class="notice[res.level].icon"
                                :style="{ color: notice[res.level].color }"
                              ></i
                              >{{ res.message }}<br />
                            </div>
                          </div>
                        </el-tooltip>
                      </div>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <!--复制广告系列的表单-->
            <el-form
              ref="copyForm"
              :model="adSeriesFormObj"
              :rules="adSeriesFormRules"
              label-width="120px"
              size="small"
            >
              <!-- 复制到个号 -->
              <el-form-item
                label="复制至"
                prop="toThirdUserId"
                v-if="!isMultiAccountManage"
              >
                <el-cascader
                  placeholder="请选择个号"
                  :options="allUseAdcounts"
                  v-model="thirdIdArr"
                  filterable
                  ref="cascader"
                  size="mini"
                  popper-class="third_user_cascader"
                  :props="{ value: 'id', children: 'thirdLoginUsers', label: 'displayName' }"
                  @change="selectedThirdUser"
                >
                  <template slot-scope="{ node, data }">
                    <span v-if="node.isLeaf">{{
                      `${data.thirdUser.displayName ? data.thirdUser.displayName : data.thirdUser.thirdUserName}${
                        data.thirdUser.thirdUserEmail ? '(' + data.thirdUser.thirdUserEmail + ')' : ''
                      }`
                    }}</span>
                    <span v-else>{{ data.name }}</span>
                  </template>
                </el-cascader>
              </el-form-item>
              <el-form-item
                label="复制至"
                prop="toAccountId"
              >
                <el-select
                  v-model="adSeriesFormObj.toAccountId"
                  @change="chooseCopyToAccount"
                  filterable
                >
                  <el-option-group
                    v-for="group in !notCurrentNum ? accountsOptions : notCurrentNumAccountsOptions"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="item in group.options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="!item.$warn.pass"
                      value-key="id"
                    >
                      <i class="el-icon-info"></i>
                      <span>{{ item.name }}</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.$warn.msg"
                        placement="left"
                        v-if="item.$warn.warn"
                      >
                        <i
                          class="el-icon-warning-outline"
                          :style="{ color: item.$warn.color }"
                        ></i>
                      </el-tooltip>
                      <p class="account-id">ID：{{ item.id }}</p>
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
              <el-form-item label="选择系列">
                <el-select
                  v-model="target"
                  multiple
                  collapse-tags
                  clearable
                  filterable
                  placeholder="请输入关键词"
                  popper-append-to-body
                  remote
                  :remote-method="remoteMethod"
                  v-loading="loading1"
                  popper-class="campaign-copy-popper"
                  reserve-keyword
                  @change="selectCampaign"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.campaignId"
                    :label="campaignOptionLabel(item)"
                    :value="item.campaignId"
                    class="campaignSelect"
                  >
                    <div class="campaign-option">
                      <p class="campaign-option__name">{{ item.campaignName }}</p>
                      <p
                        v-if="isRealCampaign(item)"
                        class="campaign-option__meta"
                      >
                        <span
                          v-if="statusDesc(item.effectiveStatus)"
                          class="campaign-option__tag"
                          :class="campaignStatusTone(statusDesc(item.effectiveStatus))"
                          >{{ statusDesc(item.effectiveStatus) }}</span
                        >
                        <span class="campaign-option__id">{{ item.campaignId }}</span>
                        <span
                          v-if="statusDesc(item.objective)"
                          class="campaign-option__obj"
                          >{{ statusDesc(item.objective) }}</span
                        >
                      </p>
                    </div>
                  </el-option>
                  <div
                    slot="empty"
                    class="empty"
                  >
                    <i class="iconfont icon-wushuju"></i>
                    <p>暂无数据</p>
                  </div>
                </el-select>
                <p class="copy-target-hint">未搜索时最多 200 个系列</p>
                <el-button
                  v-if="campaignAfter"
                  type="text"
                  size="mini"
                  @click="loadMoreCampaigns"
                  >更多系列</el-button
                >
              </el-form-item>
              <el-form-item label="复制至组">
                <target-adset-tree
                  :nodes="treeNodes"
                  :value="targetAdset"
                  :loading="loading"
                  :reach-limit="adsetReachLimit"
                  :remote-keyword="adsetKeyword"
                  :empty-text="adsetEmptyText"
                  @input="onAdsetCheck"
                  @search="searchAdsets"
                ></target-adset-tree>
                <p
                  v-if="checkedAdsetIds().length"
                  class="copy-target-hint"
                >
                  将向 {{ checkedAdsetIds().length }} 个广告组各写入
                  {{ checkedAdSeries.length * copyCount }} 条广告
                </p>
              </el-form-item>
              <el-form-item
                label="复制份数"
                prop="copys"
              >
                <el-input
                  v-model="adSeriesFormObj.copys"
                  type="number"
                  max="30"
                  min="1"
                  :inline="true"
                  style="width: 100px; margin-right: 10px"
                ></el-input>
                <span>最大30份</span>
              </el-form-item>
              <el-form-item
                label="主页"
                prop="targetPageId"
              >
                <page-select
                  v-model="adSeriesFormObj.targetPageId"
                  :page-list="accountPagesList"
                  :account-id="accountId"
                  :target-user-id="rowThirdNum"
                  :load-pages="pageLoading"
                  :show-set-status="false"
                  @change="selectPage"
                  @refresh-pages="getPage(adSeriesFormObj.toAccountId, true)"
                  @capacity-loaded="onCopyCapacityLoaded"
                ></page-select>
                <span
                  class="item"
                  style="font-size: 12px; color: #999"
                  v-show="adSeriesFormObj.targetPageId"
                >
                  总容量：{{ limit_on_ads_running_or_in_review }}，已使用：{{ ads_running_or_in_review_count }}
                </span>
              </el-form-item>
              <el-form-item
                label="像素"
                prop="targetPixelId"
              >
                <el-select
                  v-model="adSeriesFormObj.targetPixelId"
                  placeholder="请选择像素"
                  @change="checkResult = null"
                >
                  <el-option
                    :label="page.name"
                    :value="page.pixel_id"
                    v-for="page in pixelList"
                    :key="page.id"
                  >
                    {{ page.name }}
                  </el-option>
                  <div
                    slot="empty"
                    class="empty"
                    v-loading="pixelLoading"
                  >
                    <i class="iconfont icon-wushuju"></i>
                    <p>暂无数据</p>
                  </div>
                </el-select>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="强制刷新主页，清除本地缓存主页数据"
                  placement="top"
                >
                  <el-button
                    icon="el-icon-refresh"
                    @click="getPixel(adSeriesFormObj.toAccountId, true)"
                    type="text"
                    size="mini"
                    :disabled="pixelLoading"
                  ></el-button>
                </el-tooltip>
              </el-form-item>
              <el-form-item
                label="关联商品"
                prop="saleRelationType"
              >
                <el-radio-group
                  v-model="saleRelationType"
                  @change="selectSaleType"
                >
                  <p
                    v-for="item in ECSaleRelationType"
                    class="saleType"
                  >
                    <el-radio :label="item.name">{{ item.desc }}</el-radio>
                  </p>
                </el-radio-group>
                <!-- <p v-for="item in ECSaleRelationType">
                  <el-radio
                    v-model="saleRelationType"
                    :label="item.name"
                    >{{ item.desc }}</el-radio
                  >
                </p> -->
              </el-form-item>
              <el-form-item
                label="推广链接"
                prop="targetUrl"
                @change="checkResult = null"
                v-if="saleRelationType === 'assign_sale'"
              >
                <!-- <el-input v-model="adSeriesFormObj.targetUrl"></el-input> -->
                <link-autocomplete @linkInfo="linkInfo" />
              </el-form-item>
              <el-form-item
                label="网域"
                prop="targetUrl"
                @change="checkResult = null"
                v-if="saleRelationType === 'assign_sale'"
              >
                <!-- <el-input v-model="adSeriesFormObj.conversion_domain" placeholder="网域仅包含一级域和二级域，例如：giikin.com"></el-input> -->
                <web-domain
                  :initWebDomain="adSeriesFormObj.conversion_domain"
                  :webDomains="webDomains"
                  @select-change="selectChange"
                ></web-domain>
              </el-form-item>
              <add-sale
                :alwaysShowColl="true"
                :saleRelationType="saleRelationType"
                :size="120"
                :msg="saleInfoData"
                @saleInfo="saleInfo"
                ref="saleInfo"
              ></add-sale>
              <el-form-item
                label="复制后状态"
                prop="adStatus"
              >
                <!-- <el-radio-group v-model="adSeriesFormObj.isUpload"  v-if="!isInAccountCopy">
                        <el-radio-button :label="false">存入草稿箱</el-radio-button>
                        <el-radio-button :label="true">上传至Facebook</el-radio-button>
                      </el-radio-group> -->

                <el-radio-group v-model="adSeriesFormObj.adStatus">
                  <el-radio label="ACTIVE">开启</el-radio>
                  <el-radio label="PAUSED">暂停</el-radio>
                  <el-radio label="CAMPAIGN_ACTIVE">系列开启（组、广告维持原状） </el-radio>
                </el-radio-group>
                <div>
                  复制后的广告系列投放状态为{{
                    adSeriesFormObj.adStatus == 'CAMPAIGN_ACTIVE'
                      ? '系列开启（组、广告维持原状)'
                      : adSeriesFormObj.adStatus == 'PAUSED'
                      ? '暂停'
                      : '开启'
                  }}
                </div>
              </el-form-item>
              <el-form-item
                label=""
                prop="targetUrl"
                v-if="!notCurrentNum"
              >
                <ad-mood
                  v-model="adSeriesFormObj.show_mood"
                  :disabled="saleRelationType != 'default_sale'"
                ></ad-mood>
              </el-form-item>
            </el-form>
          </el-main>
          <el-footer>
            <el-row
              type="flex"
              justify="end"
            >
              <span>
                <el-button @click="$emit('close-drawer')">取消</el-button>
                <el-button
                  type="primary"
                  @click="campaignsCheck"
                  v-show="!canCopy"
                  >检测</el-button
                >
                <el-button
                  type="primary"
                  @click="confirmCopy"
                  v-show="canCopy"
                  >直接复制</el-button
                >
                <el-button
                  type="primary"
                  @click="nextStep"
                  v-show="canCopy"
                  :disabled="can"
                  >下一步，编辑</el-button
                >
              </span>
            </el-row>
          </el-footer>
        </el-container>
      </div>
      <edit-copy
        :batchEditShow.sync="batchEditShow"
        :list="checkedAdSeries"
        :initCreatAdData="initDataAdCreat"
        @get-list="$emit('reload-table')"
        :params="params"
        level="ad"
      ></edit-copy>
      <direct-copy
        :creatForm.sync="creatFormShow"
        :params="params"
        level="ad"
      ></direct-copy>
    </el-drawer>
  </div>
</template>
<script>
import webDomain from '@/views/adManagement/createAd/components/webDomain';
import mixWebDomain from '@/views/adManagement/assets/js/webDomain';
import directCopy from '@/views/adManagement/components/editCopy/components/directCopy';
import _ from 'lodash';
import {
  copyCampaignsCheck,
  copyCampaigns,
  adaccoutsHeader,
  accountPagesHeader,
  accountPixelHeader,
} from '@/api/adManagement.js';
import { historyInput } from '@/api/creatAd.js';
import { adoptVisibleSale, checkAssignSaleRisk } from '../riskLevelCheck';
import { copyAd, report, sameCampaignAdsets, otherCampaigns } from '@/api/adManagement';
import { fnCSTToYmd } from '@/utils/utils';
// import {accountPages,accountPixel} from '@/api/creatAd.js'
import copyProcess from '../../copy/copyProcess';
import editCopy from './edit';
import adMood from './adMood';
import addSale from '../../../createAd/components/addSale';
import { mapState, mapGetters } from 'vuex';
import { domainReg } from '@/utils/utils';
import linkAutocomplete from './linkAutocomplete.vue';
import getMultiAccountList from './getMultiAccountList.js';
import targetAdsetTree from './targetAdsetTree.vue';
export default {
  props: ['visible', 'editRows', 'level'],
  mixins: [copyProcess, mixWebDomain, getMultiAccountList],
  components: {
    editCopy,
    adMood,
    addSale,
    webDomain,
    linkAutocomplete,
    directCopy,
    targetAdsetTree,
    PageSelect: () => import('@/components/PageSelect/index.vue'),
  },
  data() {
    var checkUrl = (rule, value, callback) => {
      let reg = new RegExp(/^((http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?)/);
      if (value && !reg.test(value)) {
        callback(new Error('请输入正确的网址'));
      } else {
        callback();
      }
    };
    return {
      thirdIdArr: [], //级联选择下拉框数组
      pageLoading: false,
      pixelLoading: false,
      showCopyAdSeries: false, // 是否展示复制广告系列的弹窗
      isIndeterminate: false, // 是否选中全部(只选中样式)
      checkedAdSeries: [], // 已选中的广告系列
      adSeriesArr: [], // 全部广告系列的数组
      // 复制广告系列的表单
      adSeriesFormObj: {
        toThirdUserId: '',
        toAccountId: '',
        copys: 1,
        adStatus: 'ACTIVE',
        isUpload: true,
        show_mood: false,
        conversion_domain: '',
      },
      isSetSubName: false, //是否设置名称后缀
      // 复制广告系列的表单验证
      adSeriesFormRules: {
        toAccountId: [
          {
            required: true,
            message: '请选择需要复制到哪个账户',
            trigger: 'change',
          },
        ],
        copys: [{ required: true, message: '请输入复制的份数', trigger: 'blur' }],
        adStatus: [{ required: true, message: '请选择复制后的状态', trigger: 'blur' }],
        targetPageId: [{ required: false, message: '选择主页', trigger: 'blur' }],
        targetPixelId: [{ required: false, message: '选择像素', trigger: 'blur' }],
        targetUrl: [{ validator: checkUrl, trigger: 'blur' }],
      },
      // 账户列表
      accountsList: [],
      currentAccount: {},
      accountPagesList: [],
      pixelList: [],
      checkResult: null,
      checking: false,
      notice: {
        error: {
          icon: 'el-icon-circle-close',
          color: '#ff0000',
        },
        warn: {
          icon: 'el-icon-warning-outline',
          color: '#faad14',
        },
        ok: {
          icon: 'el-icon-circle-check',
          color: '#47c30f',
        },
      },
      begin: false,
      results: {},
      flag: false,
      flag1: false,
      flag2: false,
      // 个号相关
      currentNum: {},
      notCurrentNum: false,
      // 不是当前个号下的广告账号列表
      notCurrentNumAccounts: [],
      // 创建广告常量参数
      initDataAdCreat: this.$store.getters.initData,
      batchEditShow: false,
      params: null,
      domainHistory: [],
      originCampaignKey: '__ORIGIN__',
      target: [],
      lastTarget: [],
      adsetTouched: false,
      treeNodes: [],
      adsetReachLimit: false,
      adsetKeyword: '',
      campaignKeyword: '',
      campaignAfter: '',
      campaignReq: 0,
      adsetReq: 0,
      loadedCampaignKey: null,
      loading: false,
      loading1: false,
      options: [],
      optionsCamapignDef: [
        {
          campaignId: '__ORIGIN__',
          campaignName: '原始广告系列',
          effectiveStatus: { desc: '' },
          objective: { desc: '' },
        },
      ],
      adParams: {
        level: 'campaign',
        keyword: '',
        account_id: this.accountId,
        object_filtering: [],
        fields: ['name', 'id'],
        action_attribution_windows: [],
        filtering: [],
        date_start: '',
        date_end: '',
      },
      levels: {
        adset: {
          desc: '广告组',
          parent: '广告系列',
        },
        ad: {
          desc: '广告',
          parent: '广告组',
        },
      },
      targetAdset: [],
      saleRelationType: 'default_sale',
      riskCheckSeq: 0,
      riskCheckedKey: '',
      copyAccountId: '', // 复制至的账号
      saleInfoData: {}, // 商品信息
      limit_on_ads_running_or_in_review: 0, // 主页总投放
      ads_running_or_in_review_count: 0, // 主页已投放
      creatFormShow: false,
    };
  },
  computed: {
    ...mapState('num', ['selectedNum', 'numLists']),
    ...mapGetters('num', ['validNumLists']),
    numList() {
      let list = [...this.validNumLists];
      list.map((v) => {
        v.name = v.thirdUser.thirdUserName;
      });
      return list.sort(function (a, b) {
        return a.name.localeCompare(b.name, 'zh');
      });
    },
    selectNumObj() {
      return this.numLists.find((item) => item.id == this.selectedNum);
    },
    allUseAdcounts() {
      return this.$store.state.initData.allUseAdcounts;
    },
    ECSaleRelationType() {
      return this.$store.state.initData.initData?.ad?.ECSaleRelationType || [];
    },
    // 是否是跨账号复制
    isInAccountCopy() {
      if (!this.notCurrentNum) {
        return this.adSeriesFormObj.toAccountId === this.currentAccount.id;
      } else {
        return false;
      }
    },

    // numsOptions() {
    //   // this.init();
    //   return [
    //     {
    //       label: "当前个号",
    //       options: this.validNumLists.filter(
    //         (item) => item.id == this.currentRowNum
    //       ),
    //     },
    //     {
    //       label: "其他个号",
    //       options: this.validNumLists.filter(
    //         (item) => item.id != this.currentRowNum
    //       ),
    //     },
    //   ];
    // },
    notCurrentNumAccountsOptions() {
      return [
        {
          label: '广告账号',
          options: this.notCurrentNumAccounts.map((it) => {
            it.$warn = this.accountWarn(it);
            return it;
          }),
        },
      ];
    },
    accountsOptions() {
      this.currentAccount.$warn = this.accountWarn(this.currentAccount);
      return [
        { label: '当前广告账号', options: [this.currentAccount] },
        {
          label: '其他广告账号',
          options: this.accountsList
            .filter((item) => item.id !== this.currentAccount.id)
            .map((it) => {
              it.$warn = this.accountWarn(it);
              return it;
            }),
        },
      ];
    },
    canCopy() {
      // if (this.isInAccountCopy) return true;
      // if (!this.checkResult) return false;
      // if (this.checkedAdSeries.some((adSeries) => !adSeries.$checkResult.pass))
      //   return false;
      return true;
    },
    // 多账号 currentNum 当前个号
    currentRowNum() {
      if (this.checkedAdSeries && this.checkedAdSeries.length && this.checkedAdSeries[0].rowThirdNum) {
        return this.checkedAdSeries[0].rowThirdNum;
      } else {
        return this.selectedNum;
      }
    },
    copyCount() {
      const count = Number(this.adSeriesFormObj.copys);
      return Number.isFinite(count) && count > 0 ? count : 0;
    },
    adsetEmptyText() {
      if (!this.isInAccountCopy && !this.realCampaignIds().length) return '请先搜索并选择目标系列';
      if (!this.realCampaignIds().length && !this.isOriginSelected()) return '请选择系列';
      return '暂无广告组';
    },
    accountId() {
      if (this.checkedAdSeries && this.checkedAdSeries.length && this.checkedAdSeries[0].rowAccountId) {
        return this.checkedAdSeries[0].rowAccountId;
      } else {
        return this.$store.getters.accountId;
      }
    },
    rowCurrentAccount() {
      let currentLabel = localStorage.getItem('multiAccountLabel')
        ? localStorage.getItem('multiAccountLabel')
        : this.adAccountLabelList[0].id;
      let list = this.adAccountLabelList.find((v) => v.id == currentLabel).list;
      console.log(list, this.accountId);
      console.log(list.find((k) => k.id == this.accountId));
      return list.find((k) => k.id == this.accountId);
    },
  },
  mounted() {
    console.log(this.initDataAdCreat);
  },
  methods: {
    selectedThirdUser(val) {
      console.log(val);
      this.adSeriesFormObj.toThirdUserId = val[val.length - 1];
      this.chooseCopyToNum(val[val.length - 1]);
    },
    linkInfo(data, url) {
      this.adSeriesFormObj.targetUrl = url;
      this.saleInfoData = data;
    },
    selectChange(val) {
      let notNewAdd = this.apiWebDomains.includes(val);
      if (!notNewAdd) {
        let reg = /([0-9a-zA-Z-_]+\.\w{2,10})($|\/|\?)/;
        let pass = reg.test(val);
        if (pass) {
          let el = val.match(reg)[1];
          this.iptWebDomains.push(el);
          this.iptWebDomains = this.sortUniq(this.iptWebDomains);
          this.adSeriesFormObj.conversion_domain = val;
        } else {
          this.adSeriesFormObj.conversion_domain = '';
        }
      } else {
        this.adSeriesFormObj.conversion_domain = val;
      }
    },
    // 获取广告账户列表
    adaccouts(id) {
      let params = {
        keyword: '',
        limit: 10000,
        page: 1,
        id,
      };
      this.$showLoading();
      return adaccoutsHeader(params).then((res) => {
        this.$hideLoading();
        if (res.code == 200) {
          this.notCurrentNumAccounts = res.data.list && res.data.list.length ? [...res.data.list] : [];
        }
      });
    },
    isRealCampaign(item) {
      return !!(item && item.campaignId && item.campaignId !== this.originCampaignKey);
    },
    campaignOptionLabel(item) {
      return (item && item.campaignName) || '';
    },
    campaignStatusTone(status) {
      if (status === '投放中') return 'is-on';
      if (status === '已拒登' || status === '错误') return 'is-bad';
      if (status === '待审核' || status === '审核中' || status === '预先批准' || status === '待账单信息') return 'is-wait';
      return 'is-off';
    },
    isOriginSelected() {
      return (this.target || []).includes(this.originCampaignKey);
    },
    realCampaignIds() {
      return (this.target || []).filter((id) => id && id !== this.originCampaignKey);
    },
    originOption() {
      return this.optionsCamapignDef[0];
    },
    campaignQueryUserId() {
      if (this.isMultiAccountManage) return this.currentRowNum;
      if (!this.isInAccountCopy) return this.adSeriesFormObj.toThirdUserId;
      return this.currentRowNum;
    },
    adsetQueryUserId() {
      if (this.isMultiAccountManage || this.isOriginSelected() || this.isInAccountCopy) return this.currentRowNum;
      return this.adSeriesFormObj.toThirdUserId;
    },
    statusDesc(status) {
      if (!status) return '';
      if (typeof status === 'string') return status;
      return status.desc || status.key || '';
    },
    mapCampaignRow(row) {
      const status = this.labeledEnum(row.effective_status || row.status, this.adStatusOptions());
      const objective = this.labeledEnum(row.objective, this.objectiveOptions());
      return {
        campaignName: row.campaign_name || row.name,
        campaignId: row.id || row.campaign_id,
        effectiveStatus: status,
        objective,
      };
    },
    labeledEnum(value, options) {
      if (!value) return { desc: '', key: '' };
      if (typeof value === 'object') {
        const key = value.key || '';
        return { key, desc: value.desc || this.enumDesc(options, key) };
      }
      const key = String(value);
      return { key, desc: this.enumDesc(options, key) };
    },
    enumDesc(options, key) {
      if (!key) return '';
      const hit = (options || []).find((item) => item && item.key === key);
      return (hit && hit.desc) || key;
    },
    adStatusOptions() {
      const fromStore = this.initDataAdCreat && this.initDataAdCreat.AdStatus;
      if (fromStore && fromStore.length) return fromStore;
      return [
        { key: 'ACTIVE', desc: '投放中' },
        { key: 'PAUSED', desc: '已暂停' },
        { key: 'DELETED', desc: '已删除' },
        { key: 'PENDING_REVIEW', desc: '待审核' },
        { key: 'DISAPPROVED', desc: '已拒登' },
        { key: 'PREAPPROVED', desc: '预先批准' },
        { key: 'PENDING_BILLING_INFO', desc: '待账单信息' },
        { key: 'CAMPAIGN_PAUSED', desc: '广告系列暂停' },
        { key: 'ARCHIVED', desc: '已归档' },
        { key: 'ADSET_PAUSED', desc: '广告组暂停' },
        { key: 'IN_PROCESS', desc: '审核中' },
        { key: 'WITH_ISSUES', desc: '错误' },
        { key: 'NOAD', desc: '无广告' },
        { key: 'CLOSED', desc: '已关闭' },
      ];
    },
    objectiveOptions() {
      const fromStore = this.initDataAdCreat && this.initDataAdCreat.ad && this.initDataAdCreat.ad.CampaignObjective;
      if (fromStore && fromStore.length) return fromStore;
      return [
        { key: 'APP_INSTALLS', desc: '应用安装量' },
        { key: 'PAGE_LIKES', desc: '主页赞' },
        { key: 'POST_ENGAGEMENT', desc: '帖文互动' },
        { key: 'PRODUCT_CATALOG_SALES', desc: '目录促销' },
        { key: 'CONVERSIONS', desc: '销量' },
        { key: 'OUTCOME_SALES', desc: '销量' },
      ];
    },
    mergeCampaignOptions(mapped, append) {
      const byId = {};
      this.realCampaignIds().forEach((id) => {
        const selected = (this.options || []).find((item) => item.campaignId === id);
        if (selected) byId[id] = selected;
      });
      if (append) {
        (this.options || []).forEach((item) => {
          if (this.isRealCampaign(item)) byId[item.campaignId] = item;
        });
      }
      (mapped || []).forEach((item) => {
        if (this.isRealCampaign(item)) byId[item.campaignId] = item;
      });
      const selectedIds = this.realCampaignIds();
      const selected = selectedIds.map((id) => byId[id]).filter(Boolean);
      const rest = Object.keys(byId)
        .filter((id) => !selectedIds.includes(id))
        .map((id) => byId[id]);
      const head = this.isInAccountCopy ? [this.originOption()] : [];
      this.options = head.concat(selected).concat(rest);
    },
    searchCampaigns(keyword, append) {
      const query = keyword == null ? this.campaignKeyword : keyword;
      if (!append) this.campaignAfter = '';
      this.campaignKeyword = query || '';
      if (!this.campaignKeyword && !append) return;
      const seq = ++this.campaignReq;
      this.loading1 = true;
      const end = new Date();
      const start = new Date().getFullYear() + '/' + (new Date().getMonth() / 1 + 1) + '/' + new Date().getDate();
      const params = {
        ...this.adParams,
        level: 'campaign',
        keyword: this.campaignKeyword,
        account_id: this.adSeriesFormObj.toAccountId || this.accountId,
        fields: ['name', 'id', 'status', 'effective_status', 'objective'],
        object_filtering: [],
        filtering: [],
        action_attribution_windows: [],
        page_length: 50,
        after: append ? this.campaignAfter : '',
        date_start: fnCSTToYmd(new Date(start), { tag: 1 }),
        date_end: fnCSTToYmd(end, { tag: 1 }),
      };
      report(JSON.stringify(params), this, this.campaignQueryUserId())
        .then((res) => {
          if (seq !== this.campaignReq) return;
          const rows = (res.data && res.data.data) || [];
          this.mergeCampaignOptions(
            rows.map((row) => this.mapCampaignRow(row)),
            append,
          );
          this.campaignAfter = res.data && res.data.paging && res.data.paging.after ? res.data.paging.after : '';
        })
        .finally(() => {
          if (seq === this.campaignReq) this.loading1 = false;
        });
    },
    loadMoreCampaigns() {
      this.searchCampaigns(this.campaignKeyword, true);
    },
    buildAdsetTree(list) {
      const meta = {};
      (this.options || []).forEach((item) => {
        if (this.isRealCampaign(item)) meta[item.campaignId] = item;
      });
      const groups = [];
      const index = {};
      (list || []).forEach((row) => {
        if (!row || !row.adsetId || !row.campaignId) return;
        if (!index[row.campaignId]) {
          const campaign = meta[row.campaignId];
          const statusText = campaign ? this.statusDesc(campaign.effectiveStatus) : '';
          const objective = campaign ? this.statusDesc(campaign.objective) : '';
          index[row.campaignId] = {
            id: 'c-' + row.campaignId,
            name: row.campaignName || (campaign && campaign.campaignName) || row.campaignId,
            level: 'campaign',
            status: statusText,
            extra: objective,
            disabled: false,
            children: [],
          };
          groups.push(index[row.campaignId]);
        }
        index[row.campaignId].children.push({
          id: row.adsetId,
          name: row.adsetName,
          level: 'adset',
          status: this.statusDesc(row.effectiveStatus),
          code: row.adsetId,
          campaignId: row.campaignId,
        });
      });
      if (!this.isOriginSelected()) {
        this.realCampaignIds().forEach((id) => {
          if (index[id]) return;
          const campaign = meta[id];
          groups.push({
            id: 'c-' + id,
            name: (campaign && campaign.campaignName) || id,
            level: 'campaign',
            extra: '该系列下没有可选广告组',
            disabled: true,
            children: [],
          });
        });
      }
      return groups;
    },
    applyDefaultAdset(list) {
      const ids = (list || []).map((row) => row.adsetId).filter(Boolean);
      const valid = new Set(ids);
      const kept = (this.targetAdset || []).filter((id) => valid.has(id));
      if (this.adsetTouched) {
        this.targetAdset = kept;
        return;
      }
      if (!this.isOriginSelected()) {
        this.targetAdset = ids;
        return;
      }
      if (kept.length) {
        this.targetAdset = kept;
        return;
      }
      const preferred = (list || []).find((row) => row.order === 1) || (list || [])[0];
      this.targetAdset = preferred ? [preferred.adsetId] : [];
    },
    loadAdsetTree() {
      const origin = this.isOriginSelected();
      const campaignIds = this.realCampaignIds();
      const seq = ++this.adsetReq;
      if (!origin && !campaignIds.length) {
        this.treeNodes = [];
        this.targetAdset = [];
        this.adsetReachLimit = false;
        return;
      }
      const body = {
        adIds: this.adSeriesArr.map((item) => item.id),
        accountId: origin ? this.accountId : this.adSeriesFormObj.toAccountId || this.accountId,
      };
      if (!origin) body.targetCampaignIds = campaignIds;
      if (this.adsetKeyword) body.keyword = this.adsetKeyword;
      this.loading = true;
      sameCampaignAdsets(body, this.adsetQueryUserId())
        .then((res) => {
          if (seq !== this.adsetReq) return;
          const list = Array.isArray(res.data) ? res.data : [];
          this.adsetReachLimit = list.length >= 200;
          this.treeNodes = this.buildAdsetTree(list);
          this.applyDefaultAdset(list);
        })
        .finally(() => {
          if (seq === this.adsetReq) this.loading = false;
        });
    },
    searchAdsets(keyword) {
      this.adsetKeyword = keyword || '';
      this.loadAdsetTree();
    },
    onAdsetCheck(ids) {
      this.adsetTouched = true;
      this.targetAdset = ids || [];
    },
    sameAccountCopy() {
      if (this.notCurrentNum) return false;
      if (!this.currentAccount || !this.adSeriesFormObj) return false;
      return this.adSeriesFormObj.toAccountId === this.currentAccount.id;
    },
    normalizeCampaignTarget() {
      const selected = (this.target || []).slice();
      const hasOrigin = selected.includes(this.originCampaignKey);
      const real = selected.filter((id) => id && id !== this.originCampaignKey);
      let next = selected;
      if (hasOrigin && real.length) {
        const originAdded = !(this.lastTarget || []).includes(this.originCampaignKey);
        next = originAdded ? [this.originCampaignKey] : real;
      } else if (!this.sameAccountCopy() && hasOrigin) {
        next = real;
      }
      const changed = next.length !== selected.length || next.some((id, i) => id !== selected[i]);
      if (changed) {
        this.lastTarget = next.slice();
        this.target = next;
        return true;
      }
      this.lastTarget = selected.slice();
      return false;
    },
    onTargetSettled() {
      if (this.normalizeCampaignTarget()) return;
      const key = (this.target || []).join(',');
      if (key !== this.loadedCampaignKey) {
        this.adsetKeyword = '';
        this.adsetTouched = false;
        this.loadedCampaignKey = key;
      }
      this.loadAdsetTree();
    },
    selectCampaign() {
      this.normalizeCampaignTarget();
    },
    remoteMethod(query) {
      if (!query) {
        if (!this.campaignKeyword) return;
        this.campaignAfter = '';
        this.campaignKeyword = '';
        if (this.isInAccountCopy) {
          this.fetchDefaultCampaigns();
        } else {
          this.mergeCampaignOptions([], false);
        }
        return;
      }
      this.searchCampaigns(query, false);
    },
    fetchDefaultCampaigns() {
      const seq = ++this.campaignReq;
      return otherCampaigns(
        { campaignIds: this.adSeriesArr.map((v) => v.campaign_id), accountId: this.copyAccountId || this.accountId },
        this.currentRowNum,
      ).then((res) => {
        if (seq !== this.campaignReq) return;
        if (res.code == 0) {
          const list = Array.isArray(res.data) ? res.data : [];
          this.mergeCampaignOptions(list, false);
        }
      });
    },
    getCmapignList() {
      this.campaignAfter = '';
      this.campaignKeyword = '';
      this.adsetKeyword = '';
      this.adsetTouched = false;
      if (!this.isInAccountCopy) {
        this.options = [];
        this.target = [];
        this.lastTarget = [];
        this.treeNodes = [];
        this.targetAdset = [];
        this.adsetReachLimit = false;
        return;
      }
      this.target = [this.originCampaignKey];
      this.lastTarget = [this.originCampaignKey];
      this.fetchDefaultCampaigns();
    },
    messages(msg) {
      if (msg) {
        return msg.messages;
      } else {
        return [];
      }
    },
    needCheck(campaign) {
      return this.checkedAdSeries.some((f) => f.id === campaign.id);
    },
    campaignCheckResult(campaign) {
      if (this.checking) {
        return {
          checkResults: [
            {
              level: 'error',
              message: '检测中',
            },
          ],
          pass: false,
        };
      }
      let res = {
        checkResults: [],
        pass: true,
      };
      if (!this.checkResult) return res;
      if (this.checkResult.accountCheckResult) {
        res = this.checkResult.accountCheckResult;
        if (!res.pass) {
          return res;
        }
      }
      let campaignRes = this.checkResult.checkResultMap[campaign.id];
      res.checkResults = res.checkResults.concat(campaignRes.checkResults);
      res.pass = campaignRes.pass;
      return res;
    },
    getAccountList() {
      let list = [];
      this.adAccountLabelList.forEach((item) => {
        list = _.unionBy(list, item.list, 'id');
      });
      return this.isMultiAccountManage ? list : this.$store.getters.accountsList;
    },
    async open() {
      this.showCopyAdSeries = true;
      this.adSeriesFormObj.show_mood = false;
      this.notCurrentNum = false;
      this.accountsList = _.cloneDeep(this.getAccountList());
      this.currentAccount = this.isMultiAccountManage
        ? _.cloneDeep(this.rowCurrentAccount)
        : _.cloneDeep(this.$store.getters.currentAccountInfo);
      this.getAcoountPages(this.accountId, false);
      historyInput({ accountId: this.accountId, type: 'CONVERSION_DOMAIN' }, this.adSeriesFormObj.toThirdUserId).then(
        (res) => {
          this.domainHistory = res.data;
        },
      );
      this.init();
      if (this.selectedNum) {
        let statusId = this.selectNumObj.status == 'VALID' ? 1 : 2;
        let selectNumLable = (this.selectNumLable || localStorage.getItem('selectNumLable')) / 1 || statusId;
        this.thirdIdArr = [selectNumLable, this.selectedNum];
      }
      this.getCmapignList();
    },
    accountWarn(account) {
      let res = {
        pass: true,
        warn: false,
        msg: '通过',
        color: '#47c30f',
      };
      if (account.accountStatus === 2) {
        res.pass = false;
        res.warn = true;
        res.msg = '广告账户不可用';
        res.color = '#ff0000';
      } else if (account.timezoneName !== this.currentAccount.timezoneName) {
        res.msg = '广告账户时区不一致';
        res.warn = true;
        res.color = '#faad14';
      } else if (account.currency && account.currency.key !== this.currentAccount.currency.key) {
        res.msg = '广告账户币种不一致';
        res.warn = true;
        res.color = '#faad14';
      }
      return res;
    },
    // 选择商品类型
    selectSaleType(v) {
      console.log(v);
      if (v != 'assign_sale') {
        console.log(1111111);
        this.adSeriesFormObj.sale = null;
        this.adSeriesFormObj.site = null;
        this.adSeriesFormObj.targetUrl = null;
      } else {
        checkAssignSaleRisk(this);
      }
    },
    // 获取商品信息
    saleInfo(v) {
      this.adSeriesFormObj = { ...this.adSeriesFormObj, ...v };
      checkAssignSaleRisk(this);
    },
    checkedAdsetIds() {
      const loaded = new Set();
      (this.treeNodes || []).forEach((node) => {
        (node.children || []).forEach((child) => {
          if (child.level === 'adset' && child.id) loaded.add(child.id);
        });
      });
      return (this.targetAdset || []).filter((id) => loaded.has(id));
    },
    getParams() {
      adoptVisibleSale(this);
      let params = {
        source_third_user_id: this.currentRowNum, //当前个号id
        target_third_user_id: this.isMultiAccountManage ? null : this.adSeriesFormObj.toThirdUserId, //目标个号id
        source_account_id: this.accountId, //当前账号id
        target_account_id: this.adSeriesFormObj.toAccountId, //目标账号id
        source_obj_level: 'AD', //当前级别
        target_obj_level: 'ADSET', //目标级别
        source_obj_ids: this.checkedAdSeries.map((v) => v.id), //当前的id
        target_obj_id: this.checkedAdsetIds().length ? this.checkedAdsetIds().join(',') : null, //目标级别的id
        ad_status: this.adSeriesFormObj.adStatus,
        show_mood: this.adSeriesFormObj.show_mood,
        copys: this.adSeriesFormObj.copys,
        is_create_target: this.adSeriesFormObj.is_create_target,
        isSetSubName: this.isSetSubName,
        replace_option: {
          targetPageId: this.adSeriesFormObj.targetPageId || null,
          targetPixelId: this.adSeriesFormObj.targetPixelId || null,
          targetUrl: this.adSeriesFormObj.targetUrl || null,
          sale: this.saleRelationType == 'assign_sale' ? this.adSeriesFormObj.sale : null,
          site: this.adSeriesFormObj.site,
          conversion_domain: this.adSeriesFormObj.conversion_domain,
          sale_relation_type: this.saleRelationType,
        },
      };
      this.params = JSON.parse(JSON.stringify(params));
    },
    //   点击进行下一步编辑
    nextStep() {
      if (!this.checkedAdSeries.length) {
        this.$message({
          type: 'warning',
          message: '请至少选择一条数据',
        });
        return false;
      }
      if (!this.adSeriesFormObj.sale && this.notCurrentNum) {
        this.$message({
          type: 'warning',
          message: '请选择商品信息',
        });
        return false;
      }
      if (!this.adSeriesFormObj.site && this.notCurrentNum) {
        this.$message({
          type: 'warning',
          message: '请选择站点信息',
        });
        return false;
      }
      // if(!this.adSeriesFormObj.conversion_domain){
      //   this.$message({
      //     type:'warning',
      //     message:'请输入正确的网域信息'
      //   })
      //   return false;
      // }
      if (!this.checkedAdsetIds().length) {
        this.$message({
          type: 'warning',
          message: '请至少复制到一个组',
        });
        return false;
      }
      if (this.adSeriesFormObj.sale && this.adSeriesFormObj.sale.status == 4) {
        this.$confirm('该商品状态目前未上架，可能会产生无效花费；确定继续投放吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
          .then((res) => {
            this.getParams();
            this.batchEditShow = true;
          })
          .catch((res) => {});
      } else {
        this.getParams();
        this.batchEditShow = true;
      }
    },
    confirmCopy() {
      if (!this.checkedAdSeries.length) {
        this.$message({
          type: 'warning',
          message: '请至少选择一条数据',
        });
        return false;
      }
      // if (!this.adSeriesFormObj.sale && this.notCurrentNum) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择商品信息',
      //   });
      //   return false;
      // }
      if (this.$refs.saleInfo.errorGoods) {
        this.$message({
          type: 'warning',
          message: this.$refs.saleInfo.text,
        });
        return;
      }
      if (!this.adSeriesFormObj.site && this.notCurrentNum) {
        this.$message({
          type: 'warning',
          message: '请选择站点信息',
        });
        return false;
      }
      if (!this.checkedAdsetIds().length) {
        this.$message({
          type: 'warning',
          message: '请至少复制到一个组',
        });
        return false;
      }
      if (this.adSeriesFormObj.sale && this.adSeriesFormObj.sale.status == 4) {
        this.$confirm('该商品状态目前未上架，可能会产生无效花费；确定继续投放吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
          .then((res) => {
            this.getParams();
            this.creatFormShow = true;
          })
          .catch((res) => {});
      } else {
        this.getParams();
        this.creatFormShow = true;
      }
    },
    campaignsCheck() {
      this.checking = true;
      this.checkResult = null;
      const data = {
        campaignIds: [],
        adStatus: this.adSeriesFormObj.adStatus,
        accountId: this.accountId,
        copys: this.adSeriesFormObj.copys,
        toThirdUserId: this.adSeriesFormObj.toThirdUserId,
        toAccountId: this.adSeriesFormObj.toAccountId,
        replaceOption: {
          targetPageId: this.adSeriesFormObj.targetPageId,
          targetPixelId: this.adSeriesFormObj.targetPixelId,
          targetUrl: this.adSeriesFormObj.targetUrl,
          site: this.adSeriesFormObj.site,
        },
      };
      if (this.checkedAdSeries.length == 0) {
        this.$message.error('请至少选择一个广告系列');
        return false;
      }
      this.checkedAdSeries.forEach((item) => {
        data.campaignIds.push(item.id);
      });
      // this.$showLoading()
      copyCampaignsCheck(JSON.stringify(data), this.adSeriesFormObj.toThirdUserId).then((res) => {
        if (res.code == 0) {
          this.checkResult = res.data;
          this.checking = false;
          this.checkedAdSeries.forEach((camp) => {
            camp.$checkResult = this.campaignCheckResult(camp);
          });
        } else {
          this.checkResult = null;
          this.checking = false;
        }
      });
    },
    closeCopyAdSeries() {},
    // 全选
    handleCheckAllChange(v) {
      // console.log(v)
      this.checkedAdSeries = v ? this.adSeriesArr : [];
    },
    // 广告系列改变
    handleCheckedAdSeriesChange(v) {},
    getPage(id, force) {
      this.pageLoading = true;
      this.flag1 = false;
      accountPagesHeader({ accountId: id, force: force }, this.adSeriesFormObj.toThirdUserId).then((res) => {
        // console.log(res);
        let canUse = res.data.filter((v) => v.is_published);
        let notUse = res.data.filter((v) => !v.is_published);
        this.accountPagesList = canUse.concat(notUse);
        this.flag1 = true;
        this.pageLoading = false;
        if (force) {
          this.$message('更新成功');
        }
      });
    },
    getPixel(id, force) {
      this.pixelLoading = true;
      this.flag2 = false;
      accountPixelHeader({ accountId: id, force: force }, this, this.adSeriesFormObj.toThirdUserId).then((res) => {
        // console.log(res);
        this.pixelList = res.data;
        this.flag2 = true;
        this.pixelLoading = false;
        if (force) {
          this.$message('更新成功');
        }
      });
    },
    async getAcoountPages(id, force) {
      await this.getPage(id, force);
      await this.getPixel(id, force);
      this.flag = this.flag1 && this.flag2;
    },
    // 初始化
    init() {
      this.riskCheckSeq += 1;
      this.riskCheckedKey = '';
      this.adSeriesArr = _.cloneDeep(this.editRows);
      this.checking = false;
      this.checkResult = null;
      this.checkedAdSeries = this.adSeriesArr;
      this.currentAccount = this.isMultiAccountManage
        ? _.cloneDeep(this.rowCurrentAccount)
        : _.cloneDeep(this.$store.getters.currentAccountInfo);
      this.copyAccountId = this.currentAccount.id;
      this.target = [];
      this.lastTarget = [];
      this.targetAdset = [];
      this.treeNodes = [];
      this.adsetTouched = false;
      this.adsetKeyword = '';
      this.adsetReachLimit = false;
      this.adSeriesFormObj = {
        toThirdUserId: this.currentRowNum,
        toAccountId: this.currentAccount.id,
        copys: 1,
        adStatus: 'ACTIVE',
        isUpload: false,
      };
    },
    checkedItem(item) {
      item.checked = true;
    },
    // 选择要复制到的个号
    async chooseCopyToNum(v) {
      this.currentNum = this.allUseAdcounts.find((item) => item.id == v);
      this.$set(this.adSeriesFormObj, 'toAccountId', '');
      this.$set(this.adSeriesFormObj, 'targetPageId', '');
      this.$set(this.adSeriesFormObj, 'targetPixelId', '');
      this.accountPagesList = [];
      this.pixelList = [];
      if (v != this.currentRowNum) {
        // console.log("选中的不是当前个号！")
        this.notCurrentNum = true;
        await this.adaccouts(v);
      } else {
        this.adSeriesFormObj.toAccountId = this.currentAccount.id;
        this.notCurrentNum = false;
      }
    },
    // 选择要复制到的账号,判断选中的账号是否需要进行检测
    chooseCopyToAccount(v) {
      console.log(v, this.adSeriesFormObj.toAccountId, '系列id', this.thirdIdArr);
      this.copyAccountId = v;
      this.$set(this.adSeriesFormObj, 'targetPageId', '');
      this.$set(this.adSeriesFormObj, 'targetPixelId', '');
      this.flag = false;
      this.checkResult = null;
      this.accountPagesList = [];
      this.pixelList = [];
      this.target = [];
      this.lastTarget = [];
      this.targetAdset = [];
      this.treeNodes = [];
      this.adsetTouched = false;
      this.getCmapignList();
      this.getAcoountPages(this.adSeriesFormObj.toAccountId, false);
      this.$nextTick(() => {
        const form = this.$refs.copyForm;
        if (form && this.adSeriesFormObj.toAccountId) form.clearValidate('toAccountId');
      });
    },
    // 点击选择主页
    selectPage(v) {
      this.checkResult = null;
    },
    // 主页容量加载完成回调
    onCopyCapacityLoaded({ pageId, limit, used }) {
      if (this.adSeriesFormObj.targetPageId === pageId) {
        this.limit_on_ads_running_or_in_review = limit;
        this.ads_running_or_in_review_count = used;
      }
    },
  },
  watch: {
    'adSeriesFormObj.toAccountId'() {
      checkAssignSaleRisk(this);
    },
    target() {
      this.onTargetSettled();
    },
    'adSeriesFormObj.targetPixelId': {
      handler(val) {
        let curWebDomain = this.adSeriesFormObj.conversion_domain;
        let isUrl = [this.urlWebDomains].includes(curWebDomain);
        let isIpt = this.iptWebDomains.includes(curWebDomain);
        console.log('isUrl,isIpt', isUrl, isIpt);
        if (!isUrl && !isIpt) {
          this.$set(this.adSeriesFormObj, 'conversion_domain', '');
        }
        if (val) {
          this.domainsByFbpixels(val);
        }
      },
    },
    'adSeriesFormObj.targetUrl': {
      handler(val) {
        if (!val) {
          this.urlWebDomains = '';
          this.adSeriesFormObj.conversion_domain = '';
        } else {
          let reg = /^((http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?)/;
          if (reg.test(val)) {
            let el = '';
            if (val.match(domainReg) && val.match(domainReg)[0]) {
              el = val.match(domainReg)[0];
            }
            // this.$set(this.adSeriesFormObj,'conversion_domain',el)
            // this.urlWebDomains=el
          } else {
            this.$set(this.adSeriesFormObj, 'conversion_domain', '');
            this.urlWebDomains = '';
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.saleType {
  line-height: 1.5;
  margin: 8px 0;
}
.copy-target-hint {
  margin: 4px 0 0;
  color: #999;
  font-size: 12px;
  line-height: 1.4;
}
.el-main {
  height: calc(100vh - 140px);
  overflow-y: auto;
}
.copy-ad-series-container {
  .ad-series-wrapper {
    margin-bottom: 20px;
    .ad-series-title {
      background: rgb(230, 241, 255);
      color: rgb(34, 135, 236);
      line-height: 30px;
      padding: 0px 10px;
      display: flex;
    }
    .ad-series-content {
      max-height: 300px;
      overflow: auto;
      border-width: 0px 1px 1px;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-right-color: rgb(229, 230, 233);
      border-bottom-color: rgb(229, 230, 233);
      border-left-color: rgb(229, 230, 233);
      border-image: initial;
      border-top-style: initial;
      border-top-color: initial;
      padding: 10px;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}
.el-select-dropdown__item {
  height: 60px;
  .account-id {
    font-size: 12px;
    margin-left: 10px;
    line-height: 20px;
    color: #bdbcbc;
    font-weight: 300;
  }
}
</style>
<style lang="scss">
.campaign-copy-popper.el-select-dropdown {
  max-width: 560px;
}
.campaignSelect.el-select-dropdown__item {
  position: relative;
  height: auto;
  line-height: 18px;
  padding: 8px 32px 8px 12px;
  white-space: normal;
  overflow: hidden;
}
.campaign-copy-popper.el-select-dropdown.is-multiple .campaignSelect.el-select-dropdown__item.selected {
  color: #409eff;
  font-weight: 400;
  background-color: #f5f9ff;
}
.campaign-copy-popper.el-select-dropdown.is-multiple .campaignSelect.el-select-dropdown__item.selected.hover,
.campaign-copy-popper.el-select-dropdown.is-multiple .campaignSelect.el-select-dropdown__item.selected:hover {
  background-color: #f0f7ff;
}
.campaign-copy-popper.el-select-dropdown.is-multiple .campaignSelect.el-select-dropdown__item.selected::after {
  top: 50%;
  right: 12px;
  margin-top: -7px;
  font-size: 14px;
  line-height: 14px;
}
.campaign-option__name {
  color: #303133;
  font-size: 13px;
  font-weight: 400;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.campaign-option__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.campaign-option__tag {
  margin-right: 6px;
  padding: 0 6px;
  border-radius: 2px;
  background: #f4f4f5;
  color: #909399;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.campaign-option__tag.is-on {
  background: #f0f9eb;
  color: #67c23a;
}
.campaign-option__tag.is-off {
  background: #f4f4f5;
  color: #909399;
}
.campaign-option__tag.is-bad {
  background: #fef0f0;
  color: #f56c6c;
}
.campaign-option__tag.is-wait {
  background: #fdf6ec;
  color: #e6a23c;
}
.campaign-option__id,
.campaign-option__obj {
  color: #909399;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.campaign-option__obj {
  margin-left: 6px;
}
.el-select-dropdown {
  max-width: 400px;
}
.resultMessage {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  .point {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    &.success {
      background: #67c23a;
    }
    &.warn {
      background: #e6a23c;
    }
    &.success {
      background: #f56c6c;
    }
  }
}
.copy-ad-series-container {
  .ad-series-wrapper {
    .ad-series-content {
      .el-checkbox {
        width: 100%;
        .el-checkbox__label {
          width: 98%;
          .ad-series-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            .name {
              width: 90%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .name:hover {
              background: rgb(230, 241, 255);
            }
            .status {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              width: 10%;
            }
          }
        }
      }
    }
  }
  .el-loading-spinner {
    margin-top: -14px;
    .circular {
      width: 28px;
      height: 28px;
    }
  }
}
</style>
